//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import XHeader from '@/components/XHeader/XHeader'
import WechatShare from '@/components/WechatShare/WechatShare'
import InteractionList from '@/components/Interaction/InteractionList'

export default {

  props: [

  ],
  data() {
    return {
      refresh_token: '',
      show: false,
      text: '正在上传中...'
    }
  },
  computed: {
    token() {
      return this.$store.state.base.qiniuToken
    },
    user() {
      if (window.localStorage.user) {
        return JSON.parse(window.localStorage.user)
      } else {
        return this.$store.state.user.wechatInfo
      }
    },
    live() {
      return this.$store.state.live.detail
    },
  },
  methods: {

  },
  components: {
    XHeader,
    InteractionList,
    WechatShare
  },

}



// WEBPACK FOOTER //
// ./src/pages/live/Interaction.vue